var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dpdId),expression:"dpdId"}],attrs:{"type":"hidden","name":"branch_dpd_id"},domProps:{"value":(_vm.dpdId)},on:{"input":function($event){if($event.target.composing)return;_vm.dpdId=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }